var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-bar-window",class:_vm.get_notification_bar.type,on:{"click":_vm.close}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.get_notification_bar_message)}}),_c('Icon',{staticClass:"icon circled-icon",attrs:{"name":_vm.get_notification_bar.type == 'alert-window' ? 'warningSign' : 'success',"size":"20"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }